import React from "react"
import type { TreeNode } from "../types/tree-types"

export const searchNodes = (nodes: TreeNode[], searchTerm: string): TreeNode[] => {
  const term = searchTerm.trim().toLowerCase()
  if (!term) return nodes

  const filterNode = (node: TreeNode): TreeNode | null => {
    const nameMatch = node.title.toLowerCase().includes(term)
    let newChildren: TreeNode[] | undefined

    if (Array.isArray(node.children) && node.children.length > 0) {
      const filtered = node.children
        .map((child) => filterNode(child))
        .filter((c): c is TreeNode => c !== null)
      if (filtered.length > 0) newChildren = filtered
    }

    const childMatch = !!newChildren && newChildren.length > 0
    if (nameMatch || childMatch) {
      return {
        ...node,
        children: newChildren,
        isExpanded: childMatch ? true : node.isExpanded,
      }
    }
    return null
  }

  const result: TreeNode[] = []
  for (const root of nodes) {
    const pruned = filterNode(root)
    if (pruned) result.push(pruned)
  }
  return result
}

export const highlightSearchTerm = (text: string, searchTerm: string): React.ReactNode => {
  const term = searchTerm.trim()
  if (!term) return text
  const parts = text.split(new RegExp(`(${term})`, "gi"))
  return React.createElement(
    React.Fragment,
    null,
    parts.map((part, index) =>
      React.createElement(
        "span",
        {
          key: index,
          style: part.toLowerCase() === term.toLowerCase() ? { backgroundColor: "#ffecb3" } : undefined,
        },
        part,
      ),
    ),
  )
}

 
